import { registerComponent, asyncRequest } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-summary",
  class ProductSummary extends WYATTElement {
    constructor() {
      super();

      this.endpoint = `${WYATT.routes.root}products/${this.dataset.handle}?view=summary`;

      this.getProductSummary();
    }

    async getProductSummary() {
      if (WYATT.searchspring.cached.products[this.dataset.handle]) {
        this.replaceWith(
          WYATT.searchspring.cached.products[this.dataset.handle],
        );
        return;
      }

      const response = await asyncRequest(this.endpoint);

      if (response) {
        this.handleSuccessfulUpdate(response);
      }
    }

    handleSuccessfulUpdate(html) {
      const productSummary = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".product-summary");

      productSummary.classList.add(
        "product-summary--horizontal",
        "product-summary--horizontal-until-medium",
      );

      if (this.dataset.tabindex) {
        productSummary.querySelectorAll("button, a").forEach((element) => {
          element.setAttribute("tabindex", this.dataset.tabindex);
        });
      }

      WYATT.searchspring.cached.products[this.dataset.handle] = productSummary;

      this.replaceWith(productSummary);
    }
  },
);
